import { Components, Theme } from '@mui/material';

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      ...theme.typography.body2,
      borderRadius: theme.shape.controlRadius,
      backgroundColor: theme.palette.background.tooltip,
      color: theme.palette.mode === 'light' ? theme.palette.text.inversePrimary : theme.palette.text.primary,
      padding: theme.spacing(1),
      boxShadow: theme.shadows[5],
    }),
    arrow: ({ theme }) => ({
      // The `color` prop is what changes the color of the arrow displayed next
      // to the tooltip, so this just makes it match the rest of the tooltip's
      // background color
      color: theme.palette.background.tooltip,
    }),
  },
};
